import {useEffect} from 'react';
import {PageTitleKeys, pageTitles} from '../config/routeConstants';
import {useTranslation} from "react-i18next";
import {env} from "../config/environment";

export const usePageTitle = (titleInput: PageTitleKeys | string, isKey = true) => {
    const {t} = useTranslation();

    useEffect(() => {
        const brandName = t(`brand.${env.clientTheme}.productName`);

        if (isKey) {
            const key = titleInput as PageTitleKeys;
            const pageTitle = t(pageTitles[key]) || pageTitles[PageTitleKeys.Default];

            document.title = `${pageTitle} - ${brandName}`;
        } else {
            const pageTitle = titleInput as string || pageTitles[PageTitleKeys.Default];

            document.title = `${pageTitle} - ${brandName}`;
        }
    }, [titleInput, isKey, t]);
};
